import React, { useState } from "react";
import axios from "axios";
import { TextField, Button, Typography, CircularProgress } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

const API = process.env.REACT_APP_API_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    setError("");
    try {
      await axios.post(`${API}users/password_reset/`, { email });
      setMsg("✅ Reset link sent to your email.");
    } catch {
      setError("❌ Email not found or server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center space-y-6">
        <div className="flex justify-center">
          <img
            src="images/ForgotPassword.svg"
            alt="Forgot Password"
            className="h-32"
          />
        </div>

        <Typography variant="h5" className="font-semibold text-gray-800">
          Forgot Password
        </Typography>

        <form onSubmit={handleSubmit} className="space-y-4">
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: <EmailIcon className="mr-2 text-gray-500" />,
            }}
          />

          {msg && (
            <Typography className="text-green-600 text-sm">{msg}</Typography>
          )}
          {error && (
            <Typography className="text-red-600 text-sm">{error}</Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            className="bg-blue-600 text-white hover:bg-blue-700"
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Send Reset Link"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
